import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@devhop/ui";
import { format } from "date-fns";
import { XIcon } from "lucide-react";
import type { ReactNode } from "react";

type CalendarDayDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  date: string | null;
  children: ReactNode;
};

export function CalendarDayDrawer({
  open,
  onOpenChange,
  date,
  children,
}: CalendarDayDrawerProps) {
  const formattedDate = date
    ? format(new Date(`${date}T12:00:00`), "dd/MM/yyyy")
    : "";

  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction="right">
      <DrawerContent className="flex h-dvh max-h-dvh !w-[min(98vw,480px)] !max-w-[min(98vw,480px)] flex-col overflow-hidden p-0">
        <DrawerHeader className="shrink-0 border-b px-5 pb-4 pt-5 sm:px-6">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 text-left">
              <DrawerTitle className="text-lg">{formattedDate}</DrawerTitle>
              <DrawerDescription className="text-sm">
                ລາຍການໃນວັນນີ້
              </DrawerDescription>
            </div>
            <DrawerClose
              className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2"
              aria-label="ປິດ"
            >
              <XIcon className="size-4" />
            </DrawerClose>
          </div>
        </DrawerHeader>

        <div className="flex-1 overflow-y-auto px-5 py-4 sm:px-6">{children}</div>
      </DrawerContent>
    </Drawer>
  );
}
